import React, { useEffect, useRef } from "react";
import { Root as ToasterRoot, Description as ToasterDescription, Close as ToasterClose } from "@radix-ui/react-toast";
import useFlashMessenger from "../../../hooks/useFlashMessenger";
import cc from "classcat";
import { CheckCircleIcon, XCircleIcon, XMarkIcon } from "@heroicons/react/24/solid";
import { twMerge } from "tailwind-merge";
export default function FlashMessenger() {
    var _useFlashMessenger = useFlashMessenger(), message = _useFlashMessenger.message, removeMessage = _useFlashMessenger.removeMessage, opened = _useFlashMessenger.opened, setOpened = _useFlashMessenger.setOpened;
    var timeoutRef = useRef(null); // Store timeout reference
    var animationDuration = 300;
    function onOpenChange(opened) {
        setOpened(opened);
        // We want the animation to finish before removing the message
        setTimeout(function() {
            removeMessage();
        }, animationDuration);
    }
    useEffect(function() {
        setOpened(!!message);
    }, [
        message
    ]);
    // We always close the flash message after 10 seconds in case it remained opened
    useEffect(function() {
        if (!opened) {
            return;
        }
        timeoutRef.current = setTimeout(function() {
            onOpenChange(false);
        }, 10000); //! Actual duration until it is closed
        // Cleanup the timeout if `opened` changes before 10 seconds
        return function() {
            if (timeoutRef.current) {
                clearTimeout(timeoutRef.current);
                timeoutRef.current = null;
            }
        };
    }, [
        opened
    ]);
    return message && message.message && /*#__PURE__*/ React.createElement(ToasterRoot, {
        open: opened,
        onOpenChange: function(opened) {
            return onOpenChange(opened);
        },
        duration: message.duration,
        // If we want to use a variable to set the value for tailwind animation duration outside of
        // tailwind.config we have to use style property with variable name from tailwind.config
        style: {
            "--animationDuration": "".concat(animationDuration, "ms")
        },
        className: twMerge(cc([
            "flex justify-between rounded-md border-l-8 bg-white px-3 py-4 shadow-around data-[swipe=cancel]:translate-x-0 data-[swipe=move]:translate-x-toasterMove data-[state=closed]:animate-toasterOut data-[state=open]:animate-toasterIn data-[swipe=end]:animate-toasterSwipeOut dark:bg-blue-750",
            {
                "border-red-500 text-red-600": (message === null || message === void 0 ? void 0 : message.type) === "error",
                "border-green-500 text-green-500 dark:border-green-700": (message === null || message === void 0 ? void 0 : message.type) === "success"
            }
        ]))
    }, /*#__PURE__*/ React.createElement(ToasterDescription, null, /*#__PURE__*/ React.createElement("div", {
        className: "flex items-center gap-x-4"
    }, /*#__PURE__*/ React.createElement("div", null, message.type === "error" && /*#__PURE__*/ React.createElement(XCircleIcon, {
        className: "h-9 w-9"
    }), message.type === "success" && /*#__PURE__*/ React.createElement(CheckCircleIcon, {
        className: "h-9 w-9 dark:fill-green-700"
    })), /*#__PURE__*/ React.createElement("div", {
        className: "font-semibold text-black dark:text-gray-300"
    }, message.message))), /*#__PURE__*/ React.createElement(ToasterClose, null, /*#__PURE__*/ React.createElement(XMarkIcon, {
        className: "h-9 w-9 text-gray-400"
    })));
}
